import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.authenticated() && authService.isAdmin()) {
    return true;
  }
  if (authService.authenticated()) {
    return router.createUrlTree(['/dashboard']);
  }
  return router.createUrlTree(['/welcome']);
};
